import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IonRouterOutlet, ModalController } from '@ionic/angular';
import { IRezervasyonlar, RezervasyonlarFilter } from '@models/dashboard';
import { DashboardService } from '@services/apis/dashboard.service';
import { RootModalComponent } from '@shared/components/root-modal/root-modal.component';
import { IToogleButton } from '@shared/models';
import Swal from 'sweetalert2';
import { BookingsFilterComponent } from '../bookings-filter/bookings-filter.component';

@Component({
  selector: 'app-bookings-list',
  templateUrl: './bookings-list.component.html',
  styleUrls: ['./bookings-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingsListComponent implements OnInit {
  public currentStatus: number = 1;
  public rezervasyonlar: IRezervasyonlar[];
  public tumRezervasyonlar: IRezervasyonlar[];
  public rezervasyonFilter: RezervasyonlarFilter

  public toggleButtons: IToogleButton[] = [{ id: 1, name: 'DashboardModule.Bookings.Pending', url: '1' }, { id: 2, name: 'DashboardModule.Bookings.Approved', url: '2' }];

  constructor(
    private dashboardService: DashboardService,
    private modalController: ModalController,
    private routerOutlet: IonRouterOutlet,
  ) {
    this.rezervasyonFilter = new RezervasyonlarFilter();
   }

  ngOnInit(): void {
    this.getRezervasyonlar();
  }

  async getRezervasyonlar() {
    this.dashboardService.getRezervasyonlar$().subscribe(response => {
      this.rezervasyonlar = response;
      this.tumRezervasyonlar = this.rezervasyonlar;
      this.getRezervasyonlarByDurumId(this.currentStatus);
    });
  }

  getRezervasyonlarByDurumId(durumID: number) {
    this.rezervasyonlar = this.tumRezervasyonlar.filter((x) => x.durumID === durumID);
  }

  setCurrentCategory(button: IToogleButton) {
    this.currentStatus = button.id;
    this.getRezervasyonlarByDurumId(this.currentStatus);
  }

  getCurrentCategoryClass(button: IToogleButton) {
    if (button.id === this.currentStatus) {
      return 'inline-separator separator-solid separator-border-2 separator-blue';
    }
  }

  async filter() {
    const modal = await this.modalController.create({
      component: RootModalComponent,
      swipeToClose: false,
      presentingElement: this.routerOutlet.nativeEl,
      componentProps: {
        rootPage: BookingsFilterComponent,
        rezervasyonFilter: this.rezervasyonFilter
      }
    });
    modal.onDidDismiss().then(async (dismissResult) => {
      const selectedData = dismissResult.data;
      if (selectedData.dismissed) {
        if (selectedData.mekanID > 0) {
          console.log(selectedData.mekanID);
          this.rezervasyonlar = this.tumRezervasyonlar.filter((x) => x.mekanID === selectedData.mekanID);
        } else {
          this.rezervasyonlar = this.tumRezervasyonlar;
        }
      }
    });
    return await modal.present();
  }

  approve(item: number) {
    const updateItem = this.rezervasyonlar.find(item => item.durumID === item.durumID);
    const index = this.rezervasyonlar.indexOf(updateItem);
    this.rezervasyonlar[index].durumID = item;
    this.getRezervasyonlar();
    Swal.fire({
      toast: true,
      icon: 'success',
      title: 'İşlem Başarılı',
      position: 'center',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });
  }

  cancel(delItem: number) {
    this.rezervasyonlar.splice(delItem, 1);
    Swal.fire({
      toast: true,
      icon: 'success',
      title: 'İşlem Başarılı',
      position: 'center',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });
  }

}
